<div class="row top-gutter-custom">
  <div class="col-4 col-md-4 col-sm-4" *ngFor="let item of topExposureItems">
    <top-exposure-item-placeholder [name]="item.name"></top-exposure-item-placeholder>
  </div>
</div>
<div class="message-popup" *ngIf="fallbackTitle && fallbackMessage">
  <div class="title">{{fallbackTitle}}</div>
  <div class="sub-title">{{fallbackMessage}}</div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/top-exposure-placeholder/top-exposure-placeholder.component.html